import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";
export const GET_VIEWED_SCHOOLS_BY_CLASS_ID = gql`
  query GetViewedSchools($classId: Int!) {
    getViewedSchoolProfiles(schoolClassID: $classId) {
      id
      name
      visits
      schoolProfilePicture {
        ...imageFields
      }
    }
  }
  ${ImageFragment}
`;
